import clsx from 'clsx';

export const getMenuClassName =
  (styles = {}, defaultClassName) =>
  ({ state }) =>
    state === 'opening'
      ? clsx(styles.menuOpening, defaultClassName)
      : state === 'closing'
        ? clsx(styles.menuClosing, defaultClassName)
        : clsx(styles.menu, defaultClassName);
